import React from "react";
import TopNavLayout, { TopNavLayoutProps } from "../top-nav-layout/TopNavLayout";
import TopNavV2 from "../top-nav-v2/TopNavV2";

const DefaultTopNavLayout: React.FC<Omit<TopNavLayoutProps, "navContent">> = ({ ...props }) => {
    return <TopNavLayout navContent={<TopNavV2 />} {...props} />;
};

export default DefaultTopNavLayout;
